import { render, staticRenderFns } from "./AdminEducationLayout.vue?vue&type=template&id=258c1a2f&scoped=true"
import script from "./AdminEducationLayout.vue?vue&type=script&lang=js"
export * from "./AdminEducationLayout.vue?vue&type=script&lang=js"
import style0 from "./AdminEducationLayout.vue?vue&type=style&index=0&id=258c1a2f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258c1a2f",
  null
  
)

export default component.exports